import * as THREE from "three";
import Experience from "./Experience.js";
import { OrbitControls } from "three/examples/jsm/controls/OrbitControls.js";

export default class Camera {
    constructor() {
        this.experience = new Experience();
        this.sizes = this.experience.sizes;
        this.scene = this.experience.scene;
        this.canvas = this.experience.canvas;
        this.debug = this.experience.debug;

        this.params = {
            yOffset: -10,
            minDistance: 30,
            maxDistance: 130,
        };

        this.setInstance();
        this.setControls();
        this.setDebug();
    }

    setInstance() {
        this.instance = new THREE.PerspectiveCamera(
            40,
            this.sizes.width / this.sizes.height,
            0.1,
            200,
        );
        this.instance.position.set(-70, this.params.yOffset, -70);
        this.scene.add(this.instance);
    }

    setControls() {
        this.controls = new OrbitControls(this.instance, this.canvas);
        this.controls.enableDamping = true;
        this.controls.enablePan = false;
        this.controls.target.y = this.params.yOffset;
        this.controls.maxPolarAngle = Math.PI / 2;
        this.controls.maxDistance = this.params.maxDistance;
        this.controls.minDistance = this.params.minDistance;
    }

    setDebug() {
        if (this.debug.active) {
            this.debugFolder = this.debug.ui.addFolder("camera");
            this.debugFolder
                .add(this.params, "yOffset")
                .min(-100)
                .max(100)
                .step(0.1)
                .name("heightOffset")
                .onChange(() => {
                    this.instance.position.y = this.params.yOffset;
                    this.controls.target.y = this.params.yOffset;
                });
        }
    }

    resize() {
        this.instance.aspect = this.sizes.width / this.sizes.height;
        this.instance.updateProjectionMatrix();
    }

    update() {
        this.controls.update();
    }
}
